import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { BPProfilesService } from '../../bp-profiles.service';

@Component({
  selector: 'bp-profiles-dashboard',
  template: `
    <dashboard [dashboardCode]="dashboardCode" [companyCountryId]="companyCountryId" [countryId]="countryId"></dashboard>
  `
})
export class BPProfilesDashboardComponent implements OnInit, OnChanges {
  @Input() public dashboardCode:string;
  public companyCountryId:number;
  public countryId:number;

  constructor(
    private bpProfilesService:BPProfilesService
  ) {
    /**/
  }

  public ngOnInit():void {
    this.companyCountryId = this.bpProfilesService.activeProfile?.companyCountryId;
    this.countryId = this.bpProfilesService.activeProfile?.country?.id;
  }

  public ngOnChanges(changes:SimpleChanges):void {
    if (changes.dashboardCode) {
      this.dashboardCode = changes.dashboardCode.currentValue;
    }
  }
}